module.exports = __webpack_public_path__ + "img/cassette-betamax.6536f79f.svg";